import {createActions} from './api'
import {queryTypes} from '../../constants/cart'

const cart = createActions('cart')
export const fetchCart = (cached = false, type = queryTypes.FULL) =>
  cart.get({cached, query: {type}})
